import styled from 'styled-components';

export const FacialVerificationStyles = styled.div`
    ${({colors}) => `
        min-height: 600px;

        .video-frame {
            position: relative;
            margin: 0 30px;
            min-height: 300px;

            .frame-edge {
                position: absolute;
                border-width: 2px 0 0 2px;
                border-style: solid;
                border-radius: 5px 0;
                width: 50px;
                height: 50px;
                background: none;
                border-color: ${colors.primaryTwo};

                &.right {
                    right: 0;
                    transform: rotate(90deg);
                }
                &.bottom-left {
                    bottom: 30px;
                    transform: rotate(270deg);
                }
                &.bottom-right {
                    right: 0;
                    bottom: 30px;
                    transform: rotate(180deg);
                }
            }

            .video-frame-loading,
            video {
                position: absolute;
                top: 15px;
                left: 15px;
                width: 270px;
                height: 270px;
                border-radius: 50%;
                margin: auto;
                background: ${colors.primaryTwo};
                overflow: hidden;
                object-fit: cover;
            }
            video {
                -webkit-transform: scaleX(-1);
                transform: scaleX(-1);
            }

            .verification-status {
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 25px;
                min-height: 250px;
            }
        }

        .error-text {
            color: ${colors.errorFull};
            font-size: 13px;
            text-align: center;
            padding: 10px 0;
        }

        .verification_result {
            position: relative;

            svg {
                width: 60px;
                height: 60px;
            }
        }

        .merchant_info {
            .merchant_info-list {
                margin: 20px auto 0;
                max-width: 340px;
                border: 1px solid ${colors.grayFour};
                border-radius: 10px;
                overflow: hidden;
            }

            .merchant_info-row {
                display: flex;
                justify-content: space-between;
                align-items: baseline;
                gap: 16px;
                padding: 12px 16px;

                &:not(:last-child) {
                    border-bottom: 1px solid ${colors.grayFour};
                }

                span {
                    flex: 0 0 auto;
                    font-size: 13px;
                    color: ${colors.textTwo};
                }
                p {
                    margin: 0;
                    flex: 1 1 auto;
                    font-size: 13px;
                    font-weight: 600;
                    color: ${colors.blackFull};
                    text-align: right;
                    overflow-wrap: anywhere;
                }
            }
        }
    `}
`;
